// extracted by mini-css-extract-plugin
export default {"community-container":"Community_community-container__NdjwI","community-title":"Community_community-title__qGxMD"};